import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../mock';
import { Button } from './ui/button';
import IronVisionLogo from './IronVisionLogo';

const Navbar = ({ onContact }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    // Close any open modals/scroll locks that linger during nav on mobile
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }, [location.pathname]);

  const isProducts = location.pathname.startsWith('/products');
  const ctaLabel = isProducts ? 'Request Demo' : 'Contact Us';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-[#0a0e1a]/85 backdrop-blur-md border-b border-cyan-400/10' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <IronVisionLogo size={40} className="group-hover:scale-105 transition-transform" />
          <div className="flex flex-col leading-none">
            <span className="text-white font-bold tracking-wider text-lg">IRON<span className="text-cyan-400">VISION</span></span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map(link => {
            const active = link.path === '/' ? location.pathname === '/' : location.pathname.startsWith(link.path);
            return (
              <Link key={link.name} to={link.path} className="relative text-sm text-slate-200 hover:text-cyan-300 transition">
                <span className={active ? 'text-white' : ''}>{link.name}</span>
                {active && <span className="absolute -bottom-2 left-0 right-0 h-[2px] bg-cyan-400 rounded-full" />}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:block">
          <Button onClick={onContact} className="bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-semibold rounded-md px-5 h-10 shadow-[0_0_24px_rgba(34,211,238,0.35)]">
            {ctaLabel}
          </Button>
        </div>

        <button onClick={() => setOpen(v => !v)} className="md:hidden text-white p-2" aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0e1a] border-t border-cyan-400/10 max-h-[calc(100vh-5rem)] overflow-y-auto">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map(link => (
              <Link key={link.name} to={link.path} onClick={() => setOpen(false)} className="text-slate-200 hover:text-cyan-300 py-2">{link.name}</Link>
            ))}
            <Button onClick={() => { setOpen(false); onContact(); }} className="bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-semibold rounded-md">
              {ctaLabel}
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
